import { render, staticRenderFns } from "./relateRoleDialog.vue?vue&type=template&id=f26d1bd8&"
import script from "./relateRoleDialog.vue?vue&type=script&lang=js&"
export * from "./relateRoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports